module.exports = "\r\n<div [ngClass]=\"checkcontainerstyle\">\r\n    <mat-checkbox [(ngModel)]=\"value\" (change)=\"checked($event)\" [disabled]=\"disable\"></mat-checkbox>\r\n    {{label}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/checkbox.control.html
// module id = ../../../../../client/app/shared/controls/checkbox.control.html
// module chunks = main